module.exports = __webpack_public_path__ + "static/media/2_4.e2516212.png";